import { createFileRoute, useSearch } from '@tanstack/react-router'
import { ProviderAuthHandler } from '@/components/ProviderAuthHandler'
import { z } from 'zod'

export const LinkedInAuthErrorCode = {
  uninvitedEmail: 'uninvitedEmail',
  invalidCredentials: 'invalidCredentials',
  userNotFound: 'userNotFound',
  invalidToken: 'invalidToken',
  expiredToken: 'expiredToken',
  badRequest: 'badRequest',
} as const

const linkedinAuthSearchSchema = z.object({
  token: z.string().optional(),
  error: z.string().optional(),
  errorCode: z.nativeEnum(LinkedInAuthErrorCode).optional(),
})

export const Route = createFileRoute('/auth/linkedin')({
  component: () => {
    const { errorCode, error, token } = useSearch({ from: '/auth/linkedin' })
    return <ProviderAuthHandler provider="linkedin" errorCode={errorCode || ''} error={error || ''} token={token || ''} />
  },
  validateSearch: linkedinAuthSearchSchema,
})
